import LoginActionHandlerBase from './action_handler_base';
import {SYSTEM_EVENTS} from '../../../events/events';
import {GNWP_SOURCES} from '../../../components/external_links/external_links_consts';
import Event from '../../../utils/event';


export default class ForgotYourPasswordActionHandler extends LoginActionHandlerBase {
    static CLASS = 'ForgotYourPasswordActionHandler';

    actionName() {
        return 'onfyp';
    }

    execute() {
        this.serviceFactory.webLoginService().closeLoginForm();

        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
            category: 'Client_LoginPopup',
            action: 'ForgotPassword'
        });

        this.serviceFactory.openLinkService().openLink({
            source: GNWP_SOURCES.FORGOT_PASSWORD
        });
    }
}